
import { v4 as uuid } from 'uuid';
import { IResourceDescriptor } from '../Services/DataService/Model';
import { IEventArgsBase } from '../Utilities';





export interface ICorrelation {
    id: string;
    name?: string;
    shouldTrackAsEvent?: boolean;
}
export function GetCorrelation(): ICorrelation {
    
    return { id: uuid() };
}

export interface IItemDeleted extends ICorrelatedEvent {
    descriptor: IResourceDescriptor;
}

export interface ICorrelatedEvent extends IEventArgsBase {
    correlation: ICorrelation
}

export interface IGLErrorInfo {
    telemetryMgr: unknown;  // TODO: This is a temporary fix.
    name: string;
    id: string;
    correlation?: ICorrelation;
    customProperties?: { [key: string]: any; };
    shouldThrow?: boolean;
    needsToBeLogged?: boolean;
}








export class GLError extends Error {
    name: string = '';
    id: string = '';
    correlation?: ICorrelation;
    customProperties?: { [key: string]: any; }
    needsToBeLogged?: boolean = true;
    shouldThrow?: boolean;

    constructor(info: IGLErrorInfo, message?: string) {
        super(message);
        // this.name = info.telemetryMgr.GetFullName(info.name); // TODO: This is a temporary fix.
        this.id = info.id;
        this.correlation = info.correlation;
        this.customProperties = info.customProperties;
        this.needsToBeLogged = info.needsToBeLogged !== undefined ? info.needsToBeLogged : true;

        //
        // TODO: This is a temporary fix, need to figure out how to get access to AppInsights instance or recreqte Telemetry Manager.
        //
        // Promise.resolve().then(() => {
        //     info.telemetryMgr.trackException(this);
        // });
    }

    static Create(err: Error, info: IGLErrorInfo) {
        let needsToBeLogged = info.needsToBeLogged ? info.needsToBeLogged : true;

        info.needsToBeLogged = false;
        let retVal = new GLError(info, err.message);
        retVal.name = err.name;
        retVal.stack = err.stack;

        retVal.needsToBeLogged = needsToBeLogged;
        // info.telemetryMgr.trackException(retVal); // TODO: This is a temporary fix.
        return retVal;
    }
}
